"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabelStyled = void 0;

var _styledComponents = require("styled-components");

var _const = require("../../../const");

var _utils = require("../../../utils");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fontSize = function fontSize(measure) {
  return (0, _const.map)(measure, function (s) {
    return "font-size: ".concat(_const.TextSize[s], ";");
  });
};

var overlapLabelStyles = /*#__PURE__*/(0, _styledComponents.css)(["background-color:", ";color:", ";font-size:10px;font-weight:", ";line-height:1em;padding:0 5px 2px;left:17px;position:absolute;top:-0.5em;z-index:3;"], _const.Colors.white, _const.Colors.gray700, _const.FontWeightValue.light);
var FormLabelStyled = (0, _utils.styled)('label')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  ", ";\n  font-weight: 700;\n  line-height: 20px;\n  margin-bottom: 8px;\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"])), _const.Form.controlLabelColor, function (_ref) {
  var measure = _ref.measure;
  return measure && fontSize(measure);
}, function (_ref2) {
  var required = _ref2.required;
  return required && (0, _utils.asterisk)();
}, function (props) {
  return (0, _const.spacingStyle)(props);
}, function (_ref3) {
  var type = _ref3.type;
  return type === 'overlap' && overlapLabelStyles;
}, function (_ref4) {
  var isError = _ref4.isError;
  return isError && "\n      color: ".concat(_const.Colors.danger, ";\n    ");
});
exports.FormLabelStyled = FormLabelStyled;